import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import TimestampManager from '../../utils/TimestampManager';
var TimestampManagerComponent = /*#__PURE__*/function (_Component) {
  function TimestampManagerComponent() {
    var _this;
    _classCallCheck(this, TimestampManagerComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TimestampManagerComponent, [].concat(args));
    _this.state = {};
    return _this;
  }
  _inherits(TimestampManagerComponent, _Component);
  return _createClass(TimestampManagerComponent, [{
    key: "componentDidMount",
    value:
    // React Component Life Cycle
    // componentDidCatch() {}
    // componentDidUpdate() {}
    function componentDidMount() {
      TimestampManager.startTicking();
    }

    // componentWillMount() {}
    // componentWillReceiveProps() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TimestampManager.stopTicking();
    }

    // componentWillUpdate() {}
  }, {
    key: "render",
    value: function render() {
      return this.props.render(
      // Pass state and handlers to platform renderer
      {});
    }
  }]);
}(Component);
export { TimestampManagerComponent as default };